import {useScopeTranslation} from '@uigstudio/uig-nextjs-helper';

import {Text} from '~components/atoms/Text';
import FilterError from '~assets/images/icons/ui/filter-match-error.svg';
import {useFilters} from '~providers/FiltersProvider';
import Button from '~components/atoms/Button';

import {ErrorContainer, ErrorMessage, ErrorText} from './styles';

export type NoPlotsFoundProps = {
    color: 'white' | 'black';
};

const NoPlotsFound = ({color}: NoPlotsFoundProps) => {
    const t = useScopeTranslation('common', 'error');
    const {clearFilters} = useFilters();

    return (
        <ErrorContainer color={color}>
            <ErrorMessage>
                <FilterError />
                <ErrorText>{t('errorMessage')}</ErrorText>
                <Button
                    onClick={clearFilters}
                    variant={color === 'white' ? 'transparent' : 'stroked'}
                >
                    <Text>{t('clearFilters')}</Text>
                </Button>
            </ErrorMessage>
        </ErrorContainer>
    );
};

export default NoPlotsFound;
